import type { QueryClient } from '@tanstack/react-query';

export interface AuthErrorHandlerOptions {
  isAuthError: (error: unknown) => boolean;
  onAuthError: () => void;
}

export function installAuthErrorHandler(
  queryClient: QueryClient,
  { isAuthError, onAuthError }: AuthErrorHandlerOptions,
): () => void {
  let fired = false;
  const handle = (error: unknown) => {
    if (fired || !isAuthError(error)) return;
    fired = true;
    queryClient.clear();
    onAuthError();
  };

  const unsubQuery = queryClient.getQueryCache().subscribe((event) => {
    if (event.type === 'updated' && event.query.state.status === 'error') {
      handle(event.query.state.error);
    }
  });
  const unsubMutation = queryClient.getMutationCache().subscribe((event) => {
    if (event.type === 'updated' && event.mutation.state.status === 'error') {
      handle(event.mutation.state.error);
    }
  });

  return () => {
    unsubQuery();
    unsubMutation();
  };
}
